const extractTiptapText = (node) => {
  if (!node) {
    return "";
  }
  if (typeof node.text === "string") {
    return node.text;
  }
  if (Array.isArray(node.content)) {
    return node.content.map(extractTiptapText).join("");
  }
  return "";
};

// Utility function to check if a TipTap JSON schema has any non-whitespace text
export const hasTiptapText = (doc) => extractTiptapText(doc).trim().length > 0;

// Utility function to check if a TipTap JSON schema is empty
export const isEmptyTiptap = (doc) => {
  if (!doc || typeof doc !== "object" || Object.keys(doc).length === 0) {
    return true;
  }

  const content = doc.content;
  return (
    doc.type === "doc" &&
    Array.isArray(content) &&
    content.length === 1 &&
    content[0]?.type === "paragraph" &&
    !content[0]?.content
  );
};
